// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// // Focus input if Searchform is empty
	// [].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
	// 	el.addEventListener( '.submit', function ( e ) {
	// 		var search = el.querySelector( 'input' );
	// 		if ( search.value.length < 1 ) {
	// 			e.preventDefault();
	// 			search.focus();
	// 		}
	// 	} );
	// } );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
	
	
} )();


(function($) {
	$(document).on('ready', function () {
		 

		$('.search-trigger').on('click', function(e){
			$('.search-form input').show().focus();
		})
		$('.search-form input').on('blur', function(e){
			$(this).hide();
		})
		
		$(".tabs-list li a").click(function(e){
		     e.preventDefault();
		  });

		$(".tabs-list li").click(function(){
		     var tabid = $(this).find("a").attr("href");
		     $(".tabs-list li,.tabs div.tab").removeClass("active");   // removing active class from tab

		     $(".tab").hide();   // hiding open tab
		     $(tabid).show();    // show tab
		     $(this).addClass("active"); //  adding active class to clicked tab

		});
		 
		$(".showblock").click(function(e){
			e.preventDefault();
			var block = $(this).data("id");
			$('.shown').addClass('hiddenblock');
			$('.shown').removeClass('shown');
			$('#' + block).removeClass('hiddenblock');
			$('#' + block).addClass('shown');
		 });

		
		var table = $('#partnerships table');
		if (table.length) {
			table.DataTable({
				"order":[0,'asc'],
			});
		}
		
		var table = $('#vaccines table');
		if (table.length) {
			table.DataTable({});
		}

		if ($(".page-id-14 .wp-container-6").length){
		var scrolled = false;
		$(document).scroll(function () {
			var scroll = $(this).scrollTop();
			var topDist = $(".page-id-14 .wp-container-6").position();
			if (scroll > topDist.top) {
				if (!scrolled) {
				
				let chartExist = Chart.getChart("chart-vaccines");
				if (chartExist != undefined)  {
					chartExist.destroy(); 
				}
				
	  			var chart = $('#chart-vaccines');
				if (chart.length) {
				const ctx = chart;
		
				new Chart(ctx, {
					type: 'bar',
					data: {
						labels: ['COVID-19', 'DT', 'Hepatitis B', 'Influenza H1N1', 'Influenza Vaccines (seasonal)', 'Meningococcal', 'OPV 1/3', 'Rabies', 'Tetanus Toxoid'],
						datasets: [{
							label: '# of Vaccines',
							data: [14, 9, 15, 9, 16, 10, 9, 11, 11],
						}],
		
					},
					options: {
						scales: {
							y: {
								beginAtZero: true
							}
						},
						plugins: {
							title: {
							  display: true,
							  text: 'Vaccines produced by most manufacturers',
							  font: {
								size: 18,
								family: "system-ui, -apple-system, 'BasierCircleBold', Roboto, 'Helvetica Neue', Arial, sans-serif",
								color: "#082749"
								}
							}
						  }
					}
				});
				}
				scrolled = true;
				}
			}
		});
		}
		
		
		
		const lightbox = GLightbox({
		  selector: '.wp-block-gallery .wp-block-image a'
		});
		
		var map = $('#world-map');
		const markers = [
			{latLng: [42.25, 115.90], name: 'AIM Vaccine', weburl: '/member/aim_vaccine_co___ltd/'},
			{latLng: [21.43, 39.70], name: 'Arabio', weburl: '/member/arabio'},
			{latLng: [-29.740027688915614, 31.06532118095993], name: 'Aspen', weburl: '/member/Aspen'},
			{latLng: [5.812827020516464, 0.16513488096521342], name: 'Atlantic Lifesciences Ltd', style: {fill: '#5ce89e',stroke: '#5ce89e',}},
			{latLng: [17.35, 77.9], name: 'Bharat Biotech International Limited', weburl: '/member/bharat', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [-6.9, 107.50], name: 'Bio Farma', weburl: '/member/biofarma', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [17.10, 78.85], name: 'Biological E Ltd', weburl: '/member/biologicale', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [-22.87, -43.24], name: 'Bio-Manguinhos Fiocruz', weburl: '/member/biomanguinhos', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [39, 116.30], name: 'Beijing Minhai Biotechnology Co.,Ltd', weburl: '/member/minhai'},
			{latLng: [17.25, 100.60], name: 'BioNet-Asia-Co Ltd', weburl: '/member/bionetasia'},
			{latLng: [-33.93, 18.50], name: 'BioVac', weburl: '/member/biovac'},
			{latLng: [30.49, 114.55], name: 'BravoVax Co Ltd', weburl: '/member/bravovax'},
			{latLng: [36.12, 117.10], name: 'CanSino Biologics', weburl: '/member/cansino_biologics'},
			{latLng: [23.07458667078423, -82.45092563273467], name: 'Centro de Ingeniería Genética y Biotecnología (CIGB)'},
			{latLng: [39.77, 113.26], name: 'China National Biotec Group Company Limited', weburl: '/member/cnbg', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [22.70, 74.15], name: 'CPL Biologicals Private Limited', weburl: '/member/cadila'},
			{latLng: [5.757245187496835, -0.3321588176179527], name: 'DEK Vaccine Ltd', style: {fill: '#5ce89e',stroke: '#5ce89e',}},
			{latLng: [37.49, 128.05], name: 'EuBiologics Co., Ltd.', weburl: '/member/eubiologics', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [34, 129], name: 'GC Pharma formerly Greencross Corporation', weburl: '/member/greencross', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [17.648494280323625, 78.49446838249824], name: 'GCBC Vaccines Private Limited'},
			{latLng: [18.593479603665493, 73.7136985690205], name: 'Gennova Biopharmaceauticals', style: {fill: '#5ce89e',stroke: '#5ce89e',}},
			{latLng: [13.05, 80.22], name: 'GreenSignal Biopharma Limited', weburl: '/member/gsbpl'},
			{latLng: [23.77, 90.40], name: 'Incepta Vaccine Limited', weburl: '/member/incepta'},
			{latLng: [16.95, 78.3], name: 'Indian Immunologicals Ltd', weburl: '/member/indianimmu'},
			{latLng: [25.05, 102.70], name: 'Institute of Medical Biology, Chinese Academy of Medical Sciences', weburl: '/member/imbcams'},
			{latLng: [14.65, -17.43], name: 'Institut Pasteur de Dakar', weburl: '/member/institut-pasteur-de-dakar/', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [-23.56, -46.72], name: 'Instituto Butantan', weburl: '/member/butantan', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [23.07311804397729, -82.45763977691105], name: 'Instituto Finlay de Vacunas (IFV)'},
			{latLng: [38.57, 126.97], name: 'LG Chem', weburl: '/member/lgls', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [41.80, 123.40], name: 'Liaoning ChengDa Biotechnology Co., Ltd', weburl: '/member/cdbio'},
			{latLng: [25.08, 121.57], name: 'Medigen Vaccine Biologics Co.', weburl: '/member/medigen'},
			{latLng: [12.147704571249024, -86.19381796939426], name: 'Mechnikov', weburl: '/member/Mechnikov'},
			{latLng: [28.52, 77.29], name: 'Panacea Biotec Limited', weburl: '/member/pbltd', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [11.35, 76.77], name: 'Pasteur Institute India', weburl: '/member/pasteurin', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [21.01, 105.85], name: 'POLYVAC', weburl: '/member/polyvac'},
			{latLng: [13.73, 100.53], name: 'Queen Saovabha Memorial Institute', weburl: '/member/qsmi'},
			{latLng: [59.93, 30.33], name: 'Saint-Petersburg Scientific Research Institute of vaccines and sera', weburl: '/member/spbniivs'},
			{latLng: [18.50, 73.92], name: 'Serum Institute of India Ltd.', weburl: '/member/siil', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [-34.44, -58.76], name: 'Sinergium Biotech', weburl: '/member/sinergium'},
			{latLng: [40.04, 119.30], name: 'Sinovac', weburl: '/member/sinovac', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [34.40, 127.10], name: 'SK Bio', weburl: '/member/skchemicals', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [13.77, 100.52], name: 'The Government Pharmaceutical Organization', weburl: '/member/tgpo'},
			{latLng: [44.74643202181737, 20.496798448589495], name: 'Torlak', weburl: '/member/Torlak'},
			{latLng: [10.77, 106.70], name: 'Vabiotech', weburl: '/member/vabiotech'},
			{latLng: [17.43, 78.45], name: 'VINS Bioproducts Ltd', weburl: '/member/vinsbioproducts/'},
			{latLng: [25.02, 102.67], name: 'Walvax Biotechnology Co., Ltd', weburl: '/member/walvax'},
			{latLng: [24.52, 117.95], name: 'Xiamen Innovax Biotech Co.,Ltd.', weburl: '/member/innovax', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [29.576808798792317, 106.57120088935226], name: 'ZhiFei', weburl: '/member/Zhifei'},
			{latLng: [23.02, 70.44], name: 'Zydus Lifesciences Limited (Cadila Healthcare limited)', weburl: '/member/zydus', style: {fill: '#2b73ed',stroke: '#2b73ed',}},
			{latLng: [17.43, 78.45], name: 'Hyderabad (click to see the members)', style: {fill: '#333', stroke: '#333', r: '7', image: 'https://dcvmn.org/wp-content/themes/dcvmn/images/zoom-in.svg'}},
			];
		if (map.length) {
			map.vectorMap({
				map: 'world_mill_en',
				backgroundColor: '#072749',
				regionStyle: {
					initial: {
						fill: '#f6f6f6',
						"fill-opacity": 1,
						stroke: 'none',
						"stroke-width": 0,
						"stroke-opacity": 1
					},
					hover: {
						"fill-opacity": 0.8,
						cursor: 'pointer'
					},
				},
				markerStyle: {
					initial: {
						fill: '#ff7300',
						stroke: '#ff7300',
						"fill-opacity": 1,
						"stroke-width": 1,
						"stroke-opacity": 1,
						r: 5
					},
				},
				markerLabelStyle: {
					initial: {
						'font-family': 'Verdana',
						'font-size': '12',
						'font-weight': 'bold',
						'color': '#ff7300',
						'padding': '2px 4px',
						cursor: 'default',
						fill: 'black'
					},
					hover: {
						cursor: 'pointer'
					}
				},
				markers: markers,
				onMarkerClick: function(event, index) {
					if (markers[index].name == 'Hyderabad (click to see the members)') {
						map.vectorMap('get', 'mapObject').setFocus({region: 'IN', animate: true});
						map.vectorMap('get', 'mapObject').removeMarkers([index])
					} else {
						window.location.href = (markers[index].weburl);
					}
				}
				});
		}
		   
		   
		$(document).scroll(function () {
		        var scroll = $(this).scrollTop();
		        var topDist = $("#wrapper").position();
		        if (scroll > topDist.top) {
		            $('nav.navbar').addClass("fixed-top");
		        } else {
		            $('nav.navbar').removeClass("fixed-top");
		        }
		    });
			
		function changeIcon(x) {
		  if (x.classList.contains("bi-caret-right-fill")) {
		    x.classList.remove("bi-caret-right-fill");
		    x.classList.add("bi-arrow-down-circle");
		  } else if (x.classList.contains("bi-arrow-down-circle")) {
		    x.classList.add("bi-caret-right-fill");
		    x.classList.remove("bi-arrow-down-circle");
		  }
		}
		
		$('.bio').on('click', function(e){
			$('.bio p').hide();
			$(this).find('p').toggle('slow');
		})
		
	    window.sr = ScrollReveal();

	    if ($(window).width() < 768) {

	    	if ($('.timeline-content').hasClass('js--fadeInLeft')) {
	    		$('.timeline-content').removeClass('js--fadeInLeft').addClass('js--fadeInRight');
	    	}

	    	sr.reveal('.js--fadeInRight', {
	  	    origin: 'right',
	  	    distance: '300px',
	  	    easing: 'ease-in-out',
	  	    duration: 800,
	  	  });

	    } else {
  	
	    	sr.reveal('.js--fadeInLeft', {
	  	    origin: 'left',
	  	    distance: '300px',
	  		  easing: 'ease-in-out',
	  	    duration: 800,
	  	  });

	  	  sr.reveal('.js--fadeInRight', {
	  	    origin: 'right',
	  	    distance: '300px',
	  	    easing: 'ease-in-out',
	  	    duration: 800,
	  	  });

	    }
  
	    sr.reveal('.js--fadeInLeft', {
	  	    origin: 'left',
	  	    distance: '300px',
	  		  easing: 'ease-in-out',
	  	    duration: 800,
	  	  });

	  	  sr.reveal('.js--fadeInRight', {
	  	    origin: 'right',
	  	    distance: '300px',
	  	    easing: 'ease-in-out',
	  	    duration: 800,
	  	  });
		  
	});
	
	const getNumber = (counter) => {
	    return parseFloat(counter.dataset.countTo);
	};
	const getSpeed = (counter) => {
	    return parseFloat(counter.dataset.duration);
	};

	const updateTex = (counter, text) => {
	    counter.textContent = text;
	};

	const animate = (counter, countTo, duration) => {
	    let startTime = null;

	    let currentTime = Date.now();

	    const step = (currentTime) => {
	        if (!startTime) {
	            startTime = currentTime;
	        }

	        const progress = Math.min((currentTime - startTime) / duration, 1);

	        const currentNum = Math.floor(progress * countTo);

	        updateTex(counter, currentNum);

	        if (progress < 1) {
	            window.requestAnimationFrame(step);
	        } else {
	            window.cancelAnimationFrame(window.requestAnimationFrame(step));
	        }
	    };

	    window.requestAnimationFrame(step);
	};

	const counters = document.querySelectorAll('.counter');
	counters.forEach((counter) => {
	    const countTo = getNumber(counter);
	    const animationDuration = getSpeed(counter);
	  animate(counter, countTo, animationDuration);
	});
	
})(jQuery)
